module.exports = __webpack_public_path__ + "static/The-Digital-Slump-How-Your-Remote-Work-Setup-is-Aging-Your-Spine-686d56cb7d5aa61f6129538522d5a6ea.webp";